export const BANK_CODE_BY_NAME = {
    "DBS": "7171",
    "CITIBANK NA": "7214",
    "Citibank Singapore Limited": "9201",
    "HSBC Bank (Singapore) Limited": "9548",
    "OCBC": "7339",
    "Standard Chartered Bank Singapore Limited": "9496",
    "UOB": "7375",
    "BANK OF CHINA LTD": "7083",
    "CIMB Bank Berhad": "7986",
    "GXS Bank Pte. Ltd.": "9751",
    "HL Bank": "7287",
    "Maribank Singapore Private Limited": "9779",
    "RHB Bank Berhad": "7366",
    "TRUST BANK SINGAPORE LIMITED": "9733"
};

export const BANK_NAMES = Object.keys(BANK_CODE_BY_NAME);